import { render, staticRenderFns } from "./submit-user-pane.vue?vue&type=template&id=78163242&scoped=true"
import script from "./submit-user-pane.vue?vue&type=script&lang=js"
export * from "./submit-user-pane.vue?vue&type=script&lang=js"
import style0 from "./submit-user-pane.vue?vue&type=style&index=0&id=78163242&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78163242",
  null
  
)

export default component.exports